import { Effect, Actions, ofType } from '@ngrx/effects';
import { asyncScheduler, timer } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { SharedState } from '../../reducer';
import { LoadManager } from '../actions';
import { Injectable } from '@angular/core';
import {
  ManagerLivePollingActionTypes,
  ManagerLivePollingStart
} from './actions';
import {
  LiveUpdateService,
  THROTTLE_DELAY,
  getMessageDelay
} from '../../../services/live-update.service';
import { getDealFollows } from '../../reducer';
import { LiveUpdateMessage } from '../../../types/live-update.types';
import {
  switchMap,
  withLatestFrom,
  filter,
  throttleTime,
  delayWhen,
  map,
  takeUntil
} from 'rxjs/operators';

@Injectable()
export class ManagerLivePollingEffect {
  private monitorLiveUpdateStop$ = this.actions$.pipe(
    ofType(ManagerLivePollingActionTypes.StopManagerPolling)
  );

  @Effect()
  public readonly livePolling = (scheduler = asyncScheduler) =>
    this.actions$.pipe(
      ofType<ManagerLivePollingStart>(
        ManagerLivePollingActionTypes.StartManagerPolling
      ),
      switchMap(() => {
        return this.liveUpdateService.startPolling().pipe(
          withLatestFrom(this.store.pipe(select(getDealFollows))),
          filter(
            ([msg, monitorDeals]) =>
              (monitorDeals || []).indexOf(msg.DealId) > -1
          ),
          throttleTime(THROTTLE_DELAY, scheduler),
          delayWhen(([msg]) =>
            timer(getMessageDelay(msg as LiveUpdateMessage), scheduler)
          ),
          takeUntil(this.monitorLiveUpdateStop$),
          map(() => new LoadManager(false))
        );
      })
    );

  constructor(
    private store: Store<SharedState>,
    private actions$: Actions,
    private liveUpdateService: LiveUpdateService
  ) {}
}
